if (!customElements.get('aiv-expected-delivery')) {
  customElements.define('aiv-expected-delivery', class extends HTMLElement {
    connectedCallback() {
      const days = Number(this.dataset.days);
      if (!Number.isInteger(days) || days < 1 || days > 90) return;
      // Calendar-day estimate in the store's India timezone, independent of visitor timezone.
      const parts = new Intl.DateTimeFormat('en-US', {timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date());
      const part = type => Number(parts.find(item => item.type === type).value);
      const date = new Date(Date.UTC(part('year'), part('month') - 1, part('day') + days));
      const time = this.querySelector('time');
      if (!time) return;
      time.dateTime = date.toISOString().slice(0, 10);
      time.textContent = new Intl.DateTimeFormat('en-US', {timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric'}).format(date);
    }
  });
}
